import { FIELD_UPDATE_SUCCESS } from '.'

const fieldUpdateReducer = (state, action) => {
  switch (action.type) {
    case FIELD_UPDATE_SUCCESS:
      return {
        ...state,
        editor: {
          ...state.editor,
          updatedField: {
            ...state.editor.updatedField,
            ...action.payload
          }
        }
      }
    default:
      return state
  }
}

export { fieldUpdateReducer }
